import { REPO_NAMESPACE } from './default-config';

export enum CustomAppType {
    VIPPS = `${REPO_NAMESPACE}.vipps-widget`,
    APPLE_PAY_PROVISION = `${REPO_NAMESPACE}.apple-pay-provision-onboarding`,
    APPLE_PAY_PROVISION_TIPS_CARD = `${REPO_NAMESPACE}.apple-pay-provision-tips-card`,
    PENDING_CARD_TOKENS = `${REPO_NAMESPACE}.pending-card-tokens`,
    V3 = `${REPO_NAMESPACE}.v3`,
    C2P_LINK_CARD = `${REPO_NAMESPACE}.c2p-link-card`,
}
